module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/01fe593f7d8bda9fedbe0e1eaee47740.png";